<main class="reference_form-main">
  <div class="main_container">
    <form [formGroup]="appconfigurationForm">
      <div class="">
        <h3 class="form_name">AppConfiguration</h3>
        <div class="input">
          <label for="">SubSubGroup Type</label>
          <select name="" class="default_input reference-form" formControlName="type" >
              <option *ngFor="let typeInput of typesInput" [value]="typeInput">{{typeInput}}</option>
          </select>
        </div>
        <div class="input">
          <label for="">Left Value</label>
          <input type="text" class="default_input reference-form" formControlName="leftvalue" />
        </div>

        <div class="input">
          <label for="">Right Value</label>
          <input type="text" class="default_input reference-form" formControlName="rightvalue" />
        </div>


        <div class="btn_holder">
          <button class="default_primary-button" *ngIf="selectedIndex === null"
            (click)="addNew(appconfigurationForm.value)">Add</button>
          <button class="default_primary-button" *ngIf="selectedIndex !== null"
            (click)="addNew(appconfigurationForm.value)">Update</button>
          <button class="default_secondary-btn ml-2" (click)="onClearForm()">Reset</button>

        </div>

      </div>
    </form>
    <div class="display_table">
      <div class="search_container">
        <input type="text" class="default_input search" placeholder="Search for AppConfiguration" [formControl]="control"
          [appAutocomplete]="autocomplete" />
        <em class="ti-search"></em>

        <app-autocomplete #autocomplete="appAutocomplete">
          <ng-template appAutocompleteContent>
            <ng-container *ngIf="(appconfigurations | filterReference: control.value) as result">
              <app-option (click)="selectAppConfiguration(option.id)" *ngFor="let option of result" [value]="option.type">
                {{ option.type }}
              </app-option>
              <app-option class="no-result" *ngIf="!result.length">No result...</app-option>
            </ng-container>
          </ng-template>
        </app-autocomplete>
      </div>

      <div class="head">
        <span class="item">S/N</span>
        <span class="item">Type</span>
        <span class="item">Left Value</span>
        <span class="item">Right Value</span>
        <span class="item">Action</span>

      </div>

      <div class="scroll">

      </div>
      <div class="body_content">
        <div class="the_body" *ngFor="let appconfiguration of appconfigurationFormArray.get('AppConfigurations')['controls']; index as i"
          (click)="onEdit(i, appconfiguration.value)" style="cursor: pointer;" matTooltip="Click to edit"
          aria-label="Button that displays a tooltip when focused or hovered over">
          <span class="content">{{i + 1}}</span>
          <span class="content">{{appconfiguration.value.type}}</span>
          <span class="content">{{appconfiguration.value.leftvalue}}</span>
          <span class="content">{{appconfiguration.value.rightvalue}}</span>
          <span class="content" (click)="$event.stopImmediatePropagation()">
            <button class="delete_icon trash" (click)="deleteAppConfiguration(i, appconfiguration.value)">
              <em class="ti-trash"> </em> </button>
          </span>

        </div>
      </div>
      <div class="btn_holder">
        <button class="default_primary-button" (click)="onSubmit(appconfigurationFormArray.value)">Submit</button>
      </div>
    </div>
  </div>
</main>

<div class="box green_box"></div>
<div class="box pink_box"></div>
